/**
 * Капсула (pill): фон + иконка + текст. Не кнопка. Стили из ui/tokens.
 */

export interface PillOptions {
  /** Иконка (эмодзи или символ) */
  icon?: string;
  /** Текст (например число монет) */
  text?: string;
  ariaLabel?: string;
  /** Дополнительные классы для иконки (например puzzle-progress-icon) */
  iconClass?: string;
  /** Дополнительные классы для текста (например puzzle-progress) */
  textClass?: string;
}

export function createPill(options: PillOptions): HTMLElement {
  const { icon, text, ariaLabel, iconClass = 'ui-pill-icon', textClass = 'ui-pill-text' } = options;
  const wrap = document.createElement('div');
  wrap.className = 'ui-pill';
  if (ariaLabel) wrap.setAttribute('aria-label', ariaLabel);

  if (icon !== undefined) {
    const iconEl = document.createElement('span');
    iconEl.className = iconClass;
    iconEl.setAttribute('aria-hidden', 'true');
    iconEl.textContent = icon;
    wrap.appendChild(iconEl);
  }
  if (text !== undefined) {
    const textEl = document.createElement('span');
    textEl.className = textClass;
    textEl.textContent = text;
    wrap.appendChild(textEl);
  }
  return wrap;
}
